// Qobiqning IKKI o'lchami — BIR JOYDA.
//
// ⚠️ NEGA ALOHIDA FAYL: qiymatlarni `AppLayout.tsx` dan eksport qilish
// `AppHeader` ni unga bog'lardi, `AppLayout` esa headerni import qiladi —
// aylanma bog'liqlik.
//
// ⚠️ NEGA BIR JOYDA (egasi talabi, 2026-08-20): sarlavha qatori va kontent
// ustuni AYNI vertikal o'qqa tushishi kerak. Ilgari header butun enni
// olardi (`padding: 0 24px`), kontent esa markazda 960px turardi — 1920px
// li monitorda logotip `x = 24` da, kontent ustuni `x = 480` da boshlanar
// va menyuning oxirgi bandi kontentdan ancha o'ngda tugardi. Ikki songa
// bo'lingan holda ular vaqt o'tib yana ajralib ketardi.

/** Sarlavha qatori balandligi. `styles/global.css` dagi yopishqoqlik shu songa tayanadi. */
export const HEADER_HEIGHT = 56

/**
 * Kontent ustunining eng katta kengligi — KOMPYUTER uchun.
 *
 * ⚠️ Telefonda bu son hech narsani cheklamaydi (oyna 390–430px), ya'ni
 * uni o'zgartirish mobil ko'rinishga fizik jihatdan ta'sir qilmaydi.
 *
 * ⚠️ 960 dan kengaytirildi (egasi talabi, 2026-08-20): «agentlar
 * ko'pincha kompyuterda o'tiradi». O'lchangan oqibat — «Mening
 * amallarim» jadvalida abonent ustuniga 106px qolardi, ya'ni
 * TELEFONDAGI kartochkadan torroq.
 */
export const CONTENT_MAX_WIDTH = 1440

/**
 * Yopishqoq o'ng ustun sarlavha ostiga kirib ketmasin.
 *
 * `.xsib-header` `z-index: 10` bilan `top: 0` da turadi, ya'ni `top: 0`
 * bilan yopishtirilgan har qanday element uning ORTIGA kiradi.
 */
export const STICKY_TOP = HEADER_HEIGHT + 16
